import { Link, useLocation } from "react-router-dom";
import { ShieldCheck, MapPin, Users, Bell } from "lucide-react";

const ACTIONS = [
  { to: "/declare", label: "Witness Your Vote", short: "Witness", icon: ShieldCheck, primary: true, testId: "sticky-witness" },
  { to: "/elections/find-my-ward", label: "Find My Ward", short: "My Ward", icon: MapPin, testId: "sticky-ward" },
  { to: "/candidates", label: "Find a Candidate", short: "Candidates", icon: Users, testId: "sticky-candidates" },
  { to: "/alerts", label: "Sign Up for Alerts", short: "Alerts", icon: Bell, testId: "sticky-alerts" },
];

export const StickyActionBar = () => {
  const { pathname } = useLocation();
  // keep the declaration wizard distraction-free
  if (pathname.includes("/declare")) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 bg-slate-900/95 backdrop-blur-md border-t border-slate-700/60"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      role="navigation"
      aria-label="Quick actions"
      data-testid="sticky-action-bar"
    >
      <div className="wyv-container">
        <div className="grid grid-cols-4 sm:flex sm:items-center sm:justify-center sm:gap-3 py-1.5 sm:py-2">
          {ACTIONS.map((a) => (
            <Link
              key={a.to}
              to={a.to}
              data-testid={a.testId}
              className={`flex flex-col sm:flex-row items-center justify-center gap-0.5 sm:gap-2 rounded-lg px-2 sm:px-5 py-1.5 sm:py-2 min-h-[44px] text-[10px] sm:text-sm font-semibold transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white ${
                a.primary
                  ? "bg-accent text-white hover:bg-accent/90"
                  : "text-slate-200 hover:bg-white/10 hover:text-white"
              }`}
            >
              <a.icon className="h-4 w-4 sm:h-4 sm:w-4" aria-hidden="true" />
              <span className="sm:hidden">{a.short}</span>
              <span className="hidden sm:inline">{a.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
